module.exports = __webpack_public_path__ + "img/tuna.6c3a7f58.png";